import NavBar from '../../components/nav-bar/nav-bar'
import translate from '../../i18n'
import styles from '../coupon-templates-container/index.module.less'
import { Card, Space } from 'antd'
import { Outlet, useLocation } from 'react-router-dom'
import { compose } from 'redux'

const CorporateOnlyLessonDefinitionsContainer = () => {
  const location = useLocation()

  const getNavBarTitle = () => {
    const pathName = location.pathname

    if (pathName.match(/^\/corporate-only-lesson-definitions\/[0-9]+\/edit$/)) {
      return translate('navBar.editCorporateOnlyLessonDefinition')
    }

    if (pathName.match(/^\/corporate-only-lesson-definitions\/new/)) {
      return translate('navBar.newCorporateOnlyLessonDefinition')
    }

    if (pathName.match(/^\/corporate-only-lesson-definitions\/[0-9]+$/)) {
      return translate('navBar.viewCorporateOnlyLessonDefinition')
    }

    return translate('navBar.corporateOnlyLessonDefinitionsTitle')
  }

  return (
    <Space className={styles['dashboard-wrapper']} orientation="vertical">
      <NavBar title={getNavBarTitle()}></NavBar>
      <Card>
        <Outlet />
      </Card>
    </Space>
  )
}

export default compose()(CorporateOnlyLessonDefinitionsContainer)
